/* London & Country (L&C) mortgage broker partnership — LIVE.
   Single source of truth for the approved external partner URL and the
   security attributes every L&C link must use. Do NOT append tracking
   parameters to this URL — source is captured internally via the
   broker_click event instead. */
export const LANDC_PARTNER_URL = "https://www.landc.co.uk/partners/mortgagepath-uk";

/* Secure external-link attributes for all outbound L&C links. */
export const BROKER_LINK_REL = "sponsored nofollow noopener noreferrer";

/* Map an internal placement identifier to the GA4 `source` label used on the
   broker_click event. Falls back to the raw placement if unmapped. */
const GA_SOURCE_MAP = {
  calculator_broker: "calculator",
  stamp_duty_broker: "stamp_duty",
  snapshot_results_broker: "snapshot",
  guide_ftb_broker: "guide_ftb",
  guide_remortgage_broker: "guide_remortgage",
};
export const brokerGaSource = (placement) => GA_SOURCE_MAP[placement] || placement;
